/**
 * Separa a string de alergias de um convidado em tokens não vazios.
 * Pura. Corrige o bug em que "leite," (vírgula solta) gerava um token vazio
 * "" — e `ingrediente.includes("")` é sempre verdadeiro, disparando alerta
 * de alergia falso em todo ingrediente.
 */
export function parseAllergyTokens(raw) {
  return String(raw ?? '')
    .split(',')
    .map((t) => t.trim())
    .filter((t) => t.length > 0);
}
